import { OnlyFansMessageReleaseForm, TaggableUser } from '@api'

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { useToast } from '@/components/ui/toast'
import { DIALOG_TYPE } from '@/dialogs/constants'
import { openDialog } from '@/models/dialogs'
import MoreIcon from '@/modules/chatting/icons/more.svg'
import { IconButton } from '@/modules/chatting/ui/components/icon-button'
import { isGuestType, isUserType } from '@/utils/releaseForms'

import { buildTaggableCreatorsInvitationUrl } from './utils'

interface Props {
  taggable: TaggableUser | OnlyFansMessageReleaseForm
  onRemoveTag?: () => void
  onEditTag?: (id: number, name: string) => void
  onToggleShow?: () => void
}

export const TaggableItemActions = ({
  taggable,
  onRemoveTag,
  onEditTag,
  onToggleShow,
}: Props) => {
  const toast = useToast()
  const { type, user, token } = taggable
  const isUser = isUserType(type)
  const isGuest = isGuestType(type)
  const userName = user?.username ?? ''

  const handleClickCopyLink = () => {
    if (!userName) return

    navigator.clipboard.writeText(`https://onlyfans.com/${userName}`)
    toast.success('Link copied to clipboard')
  }

  const handleClickCopyUsername = () => {
    if (!userName) return

    navigator.clipboard.writeText(userName)
    toast.success('Username copied to clipboard')
  }

  const handleClickCopyInvitationLink = () => {
    if (!token) {
      return
    }

    navigator.clipboard.writeText(buildTaggableCreatorsInvitationUrl(token))
    toast.success('Link copied to clipboard')
  }

  const handleClickEditTag = () => {
    openDialog({
      type: DIALOG_TYPE.INVITE_TAGGABLE_CREATOR,
      tag: taggable,
      onEdit: onEditTag,
    })
  }

  if (!isUser && !isGuest && !onRemoveTag && !onEditTag && !onToggleShow)
    return null

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="outline-none">
        <IconButton
          icon={MoreIcon}
          tooltip="More"
          iconClassName="h-6 w-4 sm:w-6 text-secondary-300"
        />
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className="z-[70] p-2"
        align="end"
      >
        {isUser && (
          <>
            <DropdownMenuItem onClick={handleClickCopyLink}>
              Copy Link to Profile
            </DropdownMenuItem>
            <DropdownMenuItem onClick={handleClickCopyUsername}>
              Copy Username
            </DropdownMenuItem>
          </>
        )}
        {isGuest && (
          <>
            <DropdownMenuItem onClick={handleClickCopyInvitationLink}>
              Copy Invitation Link
            </DropdownMenuItem>
            <DropdownMenuItem onClick={handleClickEditTag}>
              Edit tag
            </DropdownMenuItem>
            <DropdownMenuSeparator />
          </>
        )}

        {onRemoveTag && (
          <DropdownMenuItem
            className="group"
            onClick={onRemoveTag}
          >
            <span className="group-hover:text-danger-default">Remove tag</span>
          </DropdownMenuItem>
        )}
        {onToggleShow && 'hiddenForRf' in taggable && (
          <DropdownMenuItem
            className="group"
            onClick={onToggleShow}
          >
            <span className="group-hover:text-danger-default">
              {taggable.hiddenForRf ? 'Unhide' : 'Hide'}
            </span>
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
